/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Toggle_DescriptionInputs */



/**
* | output |
* | --- |
* | "Allow your identity provider to automatically manage user accounts" |
*
* @param {Scim_Toggle_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_toggle_description = /** @type {((inputs?: Scim_Toggle_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Toggle_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erlauben Sie Ihrem Identitätsanbieter, Benutzerkonten automatisch zu verwalten")
	return /** @type {LocalizedString} */ ("Allow your identity provider to automatically manage user accounts")
});